import { PopUpGaleria } from './PopUpGaleria';

export default PopUpGaleria;
